export interface KuxErrorType extends Error {
  code?: string | number;
  status?: number;
  httpStatus?: number;
}

export enum RecordsErrorCodeEnum {
  ExceededQuota = '3042',
}
